import { coreInstance } from 'shared/axios'
import { strings } from 'shared/translations'
import { CurrentUser } from './CurrentUser'
import { updateUserInfo } from './useUpdateUserInfo'

export const getUser = () =>
  coreInstance.get<CurrentUser>('/profile').then((response) => {
    const language = strings.getLanguage() as 'en' | 'ru'
    const userInfo = response.data
    const userLanguage = userInfo.settings.language

    if (userLanguage !== language) {
      updateUserInfo({
        id: userInfo.id,
        settings: { ...userInfo.settings, language },
        socialLinks: userInfo.socialLinks,
      })
    }

    return response.data
  })
